import { View, Text, Image, StyleSheet } from "@react-pdf/renderer";
import type { PdfWidgetSnapshot } from "../pdfTypes";
import type { PdfRect } from "../pdfLayout";

const s = StyleSheet.create({
  cell: {
    position: "absolute",
    borderWidth: 1,
    borderColor: "#e8e8e8",
    borderRadius: 4,
    backgroundColor: "#fff",
    overflow: "hidden",
  },
  chartTitle: { fontSize: 10, fontWeight: 600, textAlign: "left", marginBottom: 0, color: "#1a1a1a" },
  chartHeaderRow: { flexDirection: "row", alignItems: "center" },
  chartSummary: { fontSize: 7, textAlign: "right", color: "rgba(0,0,0,0.55)" },
  chartPlaceholder: { justifyContent: "center", alignItems: "center", backgroundColor: "#f8f9fa" },
  chartPlaceholderText: { fontSize: 9, color: "#999" },
});

/** Height reserved for the chart header (title + summary) in points. */
export const CHART_HEADER_HEIGHT = 16;

export function renderChart(
  snapshot: Extract<PdfWidgetSnapshot, { type: "chart" }>,
  rect: PdfRect,
  scale: number,
  chartImage?: string,
) {
  const padH = 6;
  const padV = 6;
  const hasHeader = !!(snapshot.title || snapshot.summary);
  const headerH = hasHeader ? CHART_HEADER_HEIGHT : 2;
  const imgWidth = rect.width - 2 * padH;
  const imgHeight = rect.height - headerH - padV;

  return (
    <View style={[s.cell, { left: rect.left, top: rect.top, width: rect.width, height: rect.height }]}>
      {hasHeader && (
        <View style={[s.chartHeaderRow, { paddingTop: padV, paddingHorizontal: padH }]}>
          <Text style={[s.chartTitle, { flex: 1 }]}>{snapshot.title}</Text>
          {snapshot.summary && <Text style={s.chartSummary}>{snapshot.summary}</Text>}
        </View>
      )}
      {chartImage ? (
        <Image
          src={chartImage}
          style={{
            position: "absolute",
            left: padH,
            top: headerH,
            width: imgWidth,
            height: imgHeight,
          }}
        />
      ) : (
        <View style={[s.chartPlaceholder, {
          position: "absolute",
          left: padH,
          top: headerH,
          width: imgWidth,
          height: imgHeight,
        }]}>
          <Text style={s.chartPlaceholderText}>Chart</Text>
        </View>
      )}
    </View>
  );
}
